<!--升降急记录-->
<template lang="pug">
    <el-dialog title="比赛记录" width="80%" :append-to-body="true" :visible.sync='visible' :modal-append-to-body='false'>
        el-table(:data="tableData" style="width: 100%" border)
                el-table-column(prop='businessName',header-align='center',align='center',label='比赛名称' )
                el-table-column(prop='startTime',header-align='center',align='center',label='比赛时间' )
                el-table-column(prop='grade',header-align='center',align='center',label='所获成绩' )
                el-table-column(prop='score',header-align='center',align='center',label='所获积分' )
                el-table-column(prop='level',header-align='center',align='center',label='报名比赛时级别' )
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 30]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">返回</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    name: 'DownGradeRecorde',
    data () {
        return {
            id: '', // 升降级主键
            visible: false,
            pageSize: 10,
            pageIndex: 1,
            tableData: [],
            totalPage: 0
        }
    },
    methods: {
        init (id) {
            this.id = id
            this.visible = true
            this.getGameDetailData()
        },
        // 每页数
        sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getGameDetailData()
        },
        // 当前页
        currentChangeHandle (val) {
        this.pageIndex = val
        this.getGameDetailData()
        },
        // 获取列表数据
        getGameDetailData () {
             this.$http({
                url: this.$http.adornUrl(`/mbScore/matchDetail/${this.id}`),
                method: 'get',
                params: this.$http.adornParams({
                    page: this.pageIndex,
                    limit: this.pageSize
                 })
            }).then(data => {
                if (data && data.code === 0) {
                    this.tableData = data.data.rows
                    this.totalPage = data.data.total
                } else {
                    this.tableData = []
                    this.totalPage = 0
                }
            })
        }
    }
}
</script>
<style scoped>
</style>
